var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showQuestions)?_c('div',_vm._l((_vm.quizzes),function(quiz){return _c('div',{key:quiz._id},[_c('QuizQuestionsCmp',{attrs:{"quiz":quiz,"showMyQuestionsOnly":_vm.showMyQuestionsOnly}})],1)}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }